<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8 2C5.791 2 4 3.791 4 6v12c0 1.105.895 2 2 2h1.212L6.6 21.061c-.332.574-.135 1.307.438 1.638.574.332 1.307.135 1.638-.438L9.982 20h4.342l1.304 2.259c.332.574 1.066.771 1.641.44.574-.332.771-1.066.439-1.641L17.097 20H18c1.105 0 2-.895 2-2V6c0-2.209-1.791-4-4-4H8Zm1.5 3.2c0-.663.537-1.2 1.2-1.2h2.6c.663 0 1.2.537 1.2 1.2 0 .663-.537 1.2-1.2 1.2h-2.6c-.663 0-1.2-.537-1.2-1.2ZM6 9c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1V9Zm3 7.5c0 .828-.672 1.5-1.5 1.5S6 17.328 6 16.5 6.672 15 7.5 15s1.5.672 1.5 1.5Zm7.5 1.5c.828 0 1.5-.672 1.5-1.5s-.672-1.5-1.5-1.5-1.5.672-1.5 1.5.672 1.5 1.5 1.5Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8 1h8c2.76 0 5 2.24 5 5v12c0 1.66-1.34 3-3 3h-1.13l.25.4301c.27.48.11 1.0899-.37 1.3699-.48.27-1.09.1101-1.36-.3699L14.5601 21H9.06006l-.83008 1.4301c-.27.48-.87998.6399-1.35998.3699-.48-.28-.64-.8899-.37-1.3699L6.75 21H6c-1.66 0-3-1.34-3-3V6c0-2.76 2.24-5 5-5Zm8 2H8C6.34 3 5 4.34 5 6v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-1.66-1.34-3-3-3ZM8 7h8c1.11 0 2 .9 2 2v3c0 1.1-.89 2-2 2H8c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2Zm8 2H8v3h8V9Zm-7.5 9c-.83 0-1.5-.67-1.5-1.5S7.67 15 8.5 15s1.5.67 1.5 1.5S9.33 18 8.5 18ZM11 4h2c.55 0 1 .45 1 1s-.45 1-1 1h-2c-.55 0-1-.45-1-1s.45-1 1-1Zm6 12.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
